<script lang="ts" setup>
interface Props {
	size?: 'sm' | 'md' | 'lg'
	color?: 'blue' | 'green' | 'white'
}

const props = withDefaults(defineProps<Props>(), {
	size: 'md',
	color: 'blue',
})

const sizeClasses = {
	sm: 'w-5 h-5',
	md: 'w-5 h-5 lg:w-6 lg:h-6',
	lg: 'w-6 h-6 lg:w-8 lg:h-8',
}

const iconSizeClasses = {
	sm: 'w-3 h-3',
	md: 'w-3 h-3 lg:w-4 lg:h-4',
	lg: 'w-4 h-4 lg:w-5 lg:h-5',
}

const colorClasses = {
	blue: 'bg-[#021F58]',
	green: 'bg-[#021F58]',
	white: 'bg-white',
}

const iconColorClasses = {
	blue: 'text-white',
	green: 'text-white',
	white: 'text-[#021F58]',
}
</script>

<template>
	<div
		:class="[
			'rounded-full flex items-center justify-center',
			sizeClasses[size],
			colorClasses[color],
		]"
	>
		<svg
			:class="[iconSizeClasses[size], iconColorClasses[color]]"
			fill="none"
			stroke="currentColor"
			viewBox="0 0 24 24"
		>
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="2"
				d="M5 13l4 4L19 7"
			></path>
		</svg>
	</div>
</template>
